import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import ContestantsLayout from './layout/ContestantsLayout'
import RootLayout from './layout/RootLayout'
import Admin from './pages/Admin'
import ContestantDetails from './pages/ContestantDetails'
import ContestantList from './pages/ContestantList'
import Home from './pages/Home'
import { AdminPath } from './utils/admin/getPath'
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />}>
            <Route index element={<Home />} />
            <Route path={`/${AdminPath}`} element={<Admin />} />
            <Route path="/contestants" element={<ContestantsLayout />}>
                <Route path="/contestants" element={<ContestantList />} />
                <Route path="/contestants/:id" element={<ContestantDetails />} />
            </Route>
        </Route>
    )
)

export default router
